import { Alert, Box } from '@mui/material';
import Loading from '@components/shared/Loading';
import { Summary } from './Summary';
import {
  useCurrentReport,
  useCurrentReports,
} from '@features/campaigns/subdomains/visitation/hooks/useReports';
import { useCurrentCampaign } from '@features/campaigns/subdomains/visitation/hooks';
import { SalesDataRefreshed } from '../SalesDataRefreshed';

export const SummaryContainer = () => {
  const { campaign, isFetching: campaignLoading } = useCurrentCampaign();
  const { reports, loading: allReportsLoading } = useCurrentReports();
  const { report, salesReport, loading: reportLoading } = useCurrentReport();

  if (campaignLoading || allReportsLoading || reportLoading) return <Loading />;

  if (!campaign || !report || reports.length === 0)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return (
    <>
      {salesReport ? (
        <Box paddingBottom="1rem">
          <SalesDataRefreshed reportDate={salesReport.reportDate} />
        </Box>
      ) : null}
      <Summary
        allReports={reports}
        selectedReport={report}
        campaign={campaign}
        latestSalesReport={salesReport}
      />
    </>
  );
};
